/**************************************************
 * Nombre:       IngresoTextoEstilo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useEffect, useState} from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const IngresoTextoEstilo = ({
                                props,
                                dato,
                            }) => {
    const {register, errors, control, getValues, watch, setValue} = props
    const [value_, setValue_] = useState('')

    const cambio = (e) => {
        setValue_(e)
        setValue(dato, e)
    }

    useEffect(() => {

        let este = getValues()
        if (este[dato]) {
            cambio(este[dato])
        } else {
            cambio(este[dato])
        }


    }, [watch(dato)]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mb: 6}}>
                <ReactQuill theme="snow" value={value_} onChange={cambio} style={{width: '100%', height: 250}}

                />
            </Grid>


        </Grid>
    )

}
export default IngresoTextoEstilo